var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 13.8438C10.5326 13.8438 10.8125 13.5639 10.8125 13.2188V6.96875C10.8125 6.62362 10.5326 6.34375 10.1875 6.34375C9.84237 6.34375 9.5625 6.62362 9.5625 6.96875V13.2188C9.5625 13.5639 9.84237 13.8438 10.1875 13.8438Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 13.8438C6.15763 13.8438 6.4375 13.5639 6.4375 13.2188V6.96875C6.4375 6.62362 6.15763 6.34375 5.8125 6.34375C5.46737 6.34375 5.1875 6.62362 5.1875 6.96875V13.2188C5.1875 13.5639 5.46737 13.8438 5.8125 13.8438Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.65625C10.8451 1.65625 11.125 1.37638 11.125 1.03125C11.125 0.686125 10.8451 0.40625 10.5 0.40625H5.5C5.15487 0.40625 4.875 0.686125 4.875 1.03125C4.875 1.37638 5.15487 1.65625 5.5 1.65625H10.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 2.28125C0.779875 2.28125 0.5 2.56112 0.5 2.90625C0.5 3.25138 0.779875 3.53125 1.125 3.53125H1.75V15.0312C1.75 16.4437 2.9 17.5938 4.3125 17.5938H11.6875C13.0999 17.5938 14.25 16.4437 14.25 15.0312V3.53125H14.875C15.2201 3.53125 15.5 3.25138 15.5 2.90625C15.5 2.56112 15.2201 2.28125 14.875 2.28125H13.625H2.375H1.125ZM13 3.53125V15.0312C13 15.7562 12.4125 16.3438 11.6875 16.3438H4.3125C3.5875 16.3438 3 15.7562 3 15.0312V3.53125H13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c728fc5893636e8d88f2309b1a9fe384.svg";
export { ForwardRef as ReactComponent };